import { z } from 'zod'

const thaiErrorMap: z.ZodErrorMap = (issue) => {
  if (issue.code === 'invalid_type') {
    if (issue.expected === 'number') {
      if (
        issue.received === 'undefined' ||
        issue.received === 'null' ||
        issue.received === 'nan'
      ) {
        return { message: 'กรุณาระบุตัวเลข' }
      }
      return { message: 'กรุณาระบุเป็นตัวเลขเท่านั้น' }
    }
  }

  if (issue.code === 'too_small' && issue.type === 'number') {
    return { message: `ต้องมีค่าอย่างน้อย ${issue.minimum}` }
  }

  return { message: 'กรุณาระบุข้อมูลให้ถูกต้อง' }
}

export function setupZod() {
  z.config({
    customError: thaiErrorMap,
  })
}
